import { UseMutationOptions } from '@tanstack/react-query';

import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

type ArchiveCampaignInput = {
    id: string;
};

const useArchiveCampaign = (mutateOptions?: UseMutationOptions<unknown, Error, ArchiveCampaignInput>) =>
    useMutation<ArchiveCampaignInput>(
        MutationKeys.ARCHIVE_CAMPAIGN,
        CuredApiPaths.CAMPAIGNS_ARCHIVE,
        mutateOptions,
        ApiMethods.POST
    );

export default useArchiveCampaign;
